module.exports = __webpack_public_path__ + "assets/img/to-be-delivered.0c4c82eb.png";